import React, { ChangeEvent, FormEvent, useState } from "react";
import { logEvent } from "@src/utils/logClient";
import { Button, Heading, CheckmarkIcon, DownloadIcon, theme } from "../nessie-web";
import CommonModal, { CommonModalProps } from "./CommonModal";
import styled from "@emotion/styled";
import { useCreateConvertExperimentEvent } from "@src/utils/experiment";
import { ExternalSwitches } from "@src/utils/experiments/constants";

const ModalContent = styled("div")`
  font-size: 18px;
  line-height: 1.7;
  text-align: center;
  p:first-of-type {
    margin: 18px 0 0;
  }
  em {
    font-style: normal;
    font-weight: 700;
  }
  input {
    display: block;
    margin-bottom: 12px;
    width: 100%;
    padding: 12px 24px;
    border-radius: 99px;
    border: 2px solid ${theme.colors.taro30};
    background-color: ${theme.colors.taro10};
  }
  button {
    padding: 18px 80px;
    margin: auto;
  }
`;

const DistrictDownloadModal: React.FC<CommonModalProps> = (props) => {
  const [successMessage, setSuccessMessage] = useState(false);
  const [districtDownloadFormData, setDistrictDownloadFormData] = useState({
    name: "",
    district: "",
    phone: "",
    email: "",
  });

  const convertExperiment = useCreateConvertExperimentEvent(ExternalSwitches.WEB_EXTERNAL_DISTRICTS_PAGE);

  function handleSubmit(ev: FormEvent) {
    ev.preventDefault();
    const logData = {
      eventName: "web_external_districts_page_pdf_download",
      eventValue: "",
      metadata: [districtDownloadFormData],
      experiments: [ExternalSwitches.WEB_EXTERNAL_DISTRICTS_PAGE],
    };
    logEvent({ logData });
    convertExperiment();
    setSuccessMessage(true);

    window.open("https://static.classdojo.com/uploads/a202ae56-c578-4ead-b9ba-5fa177c5eb5f.pdf", "_blank");

    setTimeout(() => props.closeModal(), 2000);
  }

  function handleInputChange(ev: ChangeEvent<HTMLInputElement>) {
    ev.preventDefault();
    setDistrictDownloadFormData({
      ...districtDownloadFormData,
      [ev.target.name]: ev.target.value,
    });
  }

  return (
    <CommonModal noHeaderText {...props}>
      <ModalContent>
        {successMessage ? (
          <>
            <Heading>Success!</Heading>
            <CheckmarkIcon color="kiwi50" size="xxl" />
          </>
        ) : (
          <>
            <p>
              <em>Let's get connected!</em>
            </p>
            <p>Share a bit about yourself, and we'll take care of the rest:</p>
            <form onSubmit={handleSubmit}>
              <input
                id="name"
                name="name"
                value={districtDownloadFormData.name}
                onChange={handleInputChange}
                placeholder="Your name and title"
                required
              />
              <input
                id="district"
                name="district"
                value={districtDownloadFormData.district}
                onChange={handleInputChange}
                placeholder="District name"
                required
              />
              <input
                id="phone"
                name="phone"
                type="tel"
                value={districtDownloadFormData.phone}
                onChange={handleInputChange}
                placeholder="Phone number"
                required
              />
              <input
                id="email"
                name="email"
                type="email"
                value={districtDownloadFormData.email}
                onChange={handleInputChange}
                placeholder="Email address"
                required
              />
              <Button kind="plus" type="submit" icon={<DownloadIcon color="white" />}>
                Download PDF
              </Button>
            </form>
          </>
        )}
      </ModalContent>
    </CommonModal>
  );
};

export default DistrictDownloadModal;
